import { useMemo, useState } from "react";
import JobTypeFilter from "./JobTypeFilter";
import CommonGrid from "../CommonGrid/CommonGrid";
import { getJobsGridColumns, jobsGridFilters, jobsGridGlobalFilterFields } from "./gridConfig";
import ExportSelectedRows from "../../ExportCSV";
import "./ModuleGrids.scss";

const JobsGrid = ({
  data = [],
  mode = "min",
  dataKey = "Visual",
  emptyMessage = "No jobs data found.",
  tableProps = {},
  rows = 20,
  paginator,
  onNavigate,
  title = ""
}) => {
  const [typeValue, setTypeValue] = useState([]);

  // Use shared columns definition
  const columns = useMemo(() => getJobsGridColumns(mode), [mode]);

  // Use shared filters/globalFilterFields
  const maximizedFilters = jobsGridFilters;
  const maximizedGlobalFilterFields = jobsGridGlobalFilterFields;

  // Filter data based on selected Type values
  const filteredData =
    mode === "max" && typeValue?.length > 0
      ? data?.filter((row) => typeValue?.includes(row.Type))
      : data;

  const column_Names = ["FilePath", "Type"]
  
  return (
    <>
      {mode === "max" && (
        <div className="jobs-grid-filters">
          <ExportSelectedRows
            allData={filteredData}
            selectedRows={[]}
            headers={columns?.map(col => col?.field)?.filter(colNames => !column_Names?.includes(colNames))}
            filename={`${title}_Records`}
          />
          <JobTypeFilter value={typeValue} setValue={setTypeValue} />
        </div>
      )}
      <CommonGrid
        data={filteredData}
        columns={columns}
        mode={mode}
        filters={mode === "max" ? maximizedFilters : undefined}
        globalFilterFields={mode === "max" ? maximizedGlobalFilterFields : undefined}
        dataKey={dataKey}
        emptyMessage={emptyMessage}
        rows={rows}
        paginator={mode === "max" ? paginator : undefined}
        tableProps={tableProps}
        showACPFilter={true}
      />
    </>
  );
};

export default JobsGrid;